<template>
<div :class="uniqueClass">
  <kye-dialog
    :visible.sync="value"
    v-bind="dialogOption"
    title="文档生成提示"
    width="360px"
    :canResize="false"
    v-on="$listeners"
    :showFullScreenButton="false"
    @closed="removeDom"
    class="kye-preview-file-dialog"
  >
    <kye-row style="text-align:center" v-loading="true">
      <kye-col :span="24" style="margin-top:40px;">
        <span>{{info}}</span>
      </kye-col>
    </kye-row>
    <span slot="footer" class="dialog-footer">
      <kye-button type="primary" @click="removeDom">后台运行</kye-button>
    </span>
  </kye-dialog>
</div>
</template>

<script>
  import { KYE_PREVIEW_VERSION } from './constant'
  export default {
    name: 'kye-preview-file',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      bizCode: String,
      bizId: String,
      id: String,
      dialogOption: {
        type: Object,
        default: () => ({
          title: '文档生成提示',
          width: '360px',
        })
      },
      version: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        info: '正在生成预览文件，请稍后。',
        uniqueClass: KYE_PREVIEW_VERSION + this.version,
        timer: null,
        openFile: true
      }
    },
    watch: {
      value (val, old) {
        if (val) {
          this.init()
        }
      }
    },
    methods: {
      removeDom() {
        this.openFile = false
        clearTimeout(this.timer)
        this.timer = null
        this.$emit('input', false)
        if (this.parent) {
          this.parent.removeChild(this.$el)
        }
      },
      init () {
        if (!this.bizCode) {
          this.$message.warning('缺少bizCode')
          this.removeDom()
          return
        }
        if (!this.bizId) {
          this.removeDom()
          this.$message.warning('缺少bizId')
          return
        }
        this.previewDocument(this.bizCode, this.bizId, this.id)
      },
      async previewDocument (bizCode, bizId, id) {
        try {
          // this.$emit('input', true)
          const data = await this.$http('filetool.filetool.preview', {
            vo: {
              bizCode: bizCode,
              bizId: bizId,
              id
            }
          })
          if (data) {
            const { id, bizCode, bizId, remark } = data
            if (id) {
              const res = await this.$http('system.file.sign', {
                bizCode,
                bizId,
                createdBy: 0
              })
              if (res) {
                const isUrl = data.visit.includes('http')
                let url = data.visit + '/' + res
                if (isUrl) {
                  if (this.openFile) {
                    let newWindow = window.open()
                    if (url.indexOf('?') > -1) {
                      newWindow.location = url + '&inline=true'
                    } else {
                      newWindow.location = url + '?inline=true'
                    }
                  }
                } else {
                  this.$message('文件错误无法预览')
                }
              } else {
                this.$message('文件授权失败')
              }
              this.removeDom()
            } else {
              // 如果不存在id 则说明文件还在准备中，需要继续调用
              this.info = remark
              let that = this
              // this.$emit('input', true)
              this.timer = setTimeout(() => {
                this.previewDocument(that.$props.bizCode, that.$props.bizId, that.$props.id)
                clearTimeout(this.timer)
              }, 3000)
            }
          } else {
            this.$message('文件不存在')
            this.removeDom()
          }
        } catch (error) {
          this.removeDom()
        }
      }
    }
  }
</script>
<style lang="less">
.kye-preview-file-dialog{
  .el-loading-spinner .circular {
    width: 22px;
    height: 22px
  }
}

</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/preview-wrapper/preview-file.vue